import React from 'react'
import { Spinner } from '../../assets/icon/svg'

export default function LoadingCategory() {
    return (
        <div className='flex items-center justify-center h-auto w-full'>
            <Spinner color='#186cb2' size={20}/>
        </div>
    )
}
